import {
  usdc,
  usdg,
  usdp,
  usdt,
  cash,
  btc,
  eth,
  sol,
  usdsui,
} from '@sail/icons/react/BrandIcon';
import type {OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum} from '@stripe-internal/data-v1/schema/types';
import {absurd} from 'src/utils/absurd';

export const getCurrencyIcon = (
  assetCode: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum,
) => {
  switch (assetCode) {
    case 'usdc':
      return usdc;
    case 'usdp':
      return usdp;
    case 'usdg':
      return usdg;
    case 'cash':
    case 'phantom_cash':
      return cash;
    case 'usdt':
      return usdt;
    case 'btc':
      return btc;
    case 'eth':
      return eth;
    case 'sol':
      return sol;
    case 'usdsui':
      return usdsui;
    default:
      return absurd(assetCode);
  }
};
